<app-notifications-banner *ngIf="notification" [notification]="notification"></app-notifications-banner>
